module.exports = __webpack_public_path__ + "static/reg-suit-logo-326bcabb1f0b7bf004a36631aaace0d6.jpg";